import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next, useTranslation } from "react-i18next";
import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation, useNavigationType } from "react-router-dom";
import { toPublicUrl } from "./services/PublicUrl";
import Home from "./pages/Home/Home";
import VueEnsemblePage from "./pages/Overview/VueEnsemblePage";
import SuiviPage from "./pages/ValeurPage/SuiviPage";
import PratiquePage from "./pages/ValeurPage/PratiquePage";
import AlertePage from "./pages/ValeurPage/AlertePage";

require("dayjs/locale/fr");

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: "en",
        supportedLngs: ["fr", "en"],
        backend: {
            loadPath: toPublicUrl("/locales/{{lng}}/{{ns}}.json")
        }
    });

dayjs.extend(relativeTime);
dayjs.locale(i18n.language);

function App() {
    const action = useNavigationType();
    const location = useLocation();
    const pathname = location.pathname;

    useTranslation();

    useEffect(() => {
        if (action !== "POP") {
            window.scrollTo(0, 0);
        }
    }, [action, pathname]);

    useEffect(() => {
        document.title = pathname.includes("vue-ensemble")
            ? "Vue d'ensemble"
            : "UP CARE";
    }, [pathname]);

    return (
        <Routes>
            <Route index element={<Navigate to="/vue-ensemble" replace />} />
            <Route path="/" element={<Navigate to="/vue-ensemble" replace />} />
            <Route path="/Home" element={<Home />} />
            <Route path="/Application" element={<Navigate to="/vue-ensemble" replace />} />
            <Route path="/Application/Home" element={<Home />} />
            <Route path="/vue-ensemble" element={<VueEnsemblePage />} />
            <Route path="/accompagnement" element={<PratiquePage />} />
            <Route path="/suivi" element={<SuiviPage />} />
            <Route path="/calendrier" element={<AlertePage />} />
            <Route path="/TableauDeBord" element={<Navigate to="/vue-ensemble" replace />} />
            <Route path="*" element={<Navigate to="/vue-ensemble" replace />} />
        </Routes>
    );
}

export default App;
